
export const state = {
  step: 'dadosTitular'
};

export const getters = {
  step: state => state.step
}

export const mutations = {
  setStep: (state, payload) => {state.step = payload;}
}

export const actions = {
  setStep({commit}, payload) {
    commit('setStep', payload);
  }
}
